(() => {
	// ===========================================================================
	// Product Hero — Image Gallery
	// Wraps images in a .product-hero__stage, then builds the thumbnail strip.
	// ===========================================================================
	document.querySelectorAll('.product-hero__media').forEach((media) => {
		const images = Array.from(media.querySelectorAll('.wp-block-image'));

		if (images.length === 0) {
			return;
		}

		// Wrap all images in a stage div
		const stage = document.createElement('div');
		stage.className = 'product-hero__stage';
		media.insertBefore(stage, images[0]);
		images.forEach((fig) => {
			stage.appendChild(fig);
		});

		// Nothing more to do with a single image
		if (images.length < 2) {
			return;
		}

		// Build thumbnail strip
		const thumbs = document.createElement('div');
		thumbs.className = 'product-hero__thumbs';

		images.forEach((figure, i) => {
			const sourceImg = figure.querySelector('img');
			if (!sourceImg) {
				return;
			}

			const btn = document.createElement('button');
			btn.type = 'button';
			btn.setAttribute('aria-label', sourceImg.alt || `Image ${i + 1}`);
			if (i === 0) btn.classList.add('is-active');

			const img = document.createElement('img');
			img.src = sourceImg.src;
			img.alt = '';
			img.setAttribute('aria-hidden', 'true');

			btn.appendChild(img);
			thumbs.appendChild(btn);

			btn.addEventListener('click', () => {
				if (btn.classList.contains('is-active')) return;

				// Crossfade: swap .is-active on stage images
				images.forEach((f) => {
					f.classList.remove('is-active');
				});
				figure.classList.add('is-active');

				// Swap active thumbnail
				thumbs.querySelectorAll('button').forEach((b) => {
					b.classList.remove('is-active');
				});
				btn.classList.add('is-active');
			});
		});

		media.appendChild(thumbs);
	});

	// ===========================================================================
	// Product Hero — Info Tabs
	// Tabs inside .product-hero__tabs toggle panels inside .product-hero__panels.
	// Buttons and panels are matched by index.
	// ===========================================================================
	document.querySelectorAll('.is-style-product-hero').forEach((hero) => {
		const tabContainer = hero.querySelector('.product-hero__tabs');
		const panelContainer = hero.querySelector('.product-hero__panels');

		if (!tabContainer || !panelContainer) return;

		const tabs = Array.from(tabContainer.querySelectorAll('.wp-block-button__link'));
		const wrappers = Array.from(tabContainer.querySelectorAll('.wp-block-button'));
		const panels = Array.from(panelContainer.children);

		if (tabs.length === 0 || panels.length === 0) {
			return;
		}

		const setTabState = (activeIndex) => {
			wrappers.forEach((w, i) => {
				const link = tabs[i];
				const isActive = i === activeIndex;

				// Always outline — active state handled via aria-selected in CSS
				w.classList.add('is-style-outline');
				w.classList.remove('is-style-fill');

				// Link colour classes
				link.classList.toggle('has-white-color', isActive);
				link.classList.toggle('has-primary-color', !isActive);
				link.classList.add('has-text-color', 'has-link-color');

				// ARIA
				link.setAttribute('aria-selected', isActive ? 'true' : 'false');
				link.setAttribute('role', 'tab');
			});

			panels.forEach((p, i) => {
				p.classList.toggle('is-active', i === activeIndex);
			});
		};

		// Set initial state
		setTabState(0);

		tabs.forEach((tab, i) => {
			tab.addEventListener('click', (e) => {
				e.preventDefault();
				if (tab.getAttribute('aria-selected') === 'true') return;
				setTabState(i);
			});
		});
	});

	document.querySelectorAll('.wp-block-video').forEach((videoBlock) => {
		var video = videoBlock.querySelector('video');
		var caption = videoBlock.querySelector('figcaption');
		if (!video || !caption) {
			return;
		}

		caption.addEventListener(
			'click',
			(e) => {
				e.stopPropagation();
				video.play();
				caption.classList.add('hidden');
			},
			{ once: true }
		);

		video.addEventListener('click', () => {});

		video.addEventListener('play', () => {
			caption.classList.add('hidden');
		});
	});

	// Header

	// Add a modal overlay that is triggered when clicking on an element with [href="#search"]
	document.querySelectorAll('[href="#search"]').forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			const searchModal = document.getElementById('search-modal');
			const isActive = searchModal.classList.contains('active');
			if (isActive) {
				searchModal.classList.remove('active');
				document.body.classList.remove('no-scroll');
				link.classList.remove('open');
			} else {
				searchModal.classList.add('active');
				document.body.classList.add('no-scroll');
				link.classList.add('open');
				searchModal.querySelector('input.orig')?.focus({ preventScroll: true });
			}
		});
	});

	// Close the search modal on ESC
	document.addEventListener('keydown', (e) => {
		if (e.key !== 'Escape') return;
		const searchModal = document.getElementById('search-modal');
		if (!searchModal?.classList.contains('active')) return;
		searchModal.classList.remove('active');
		document.body.classList.remove('no-scroll');
		document.querySelectorAll('[href="#search"]').forEach((link) => link.classList.remove('open'));
		const searchResults = document.getElementById('ajaxsearchprores1_1');
		if (searchResults) searchResults.style.display = 'none';
		searchModal.querySelectorAll('input[name="phrase"]').forEach((input) => (input.value = ''));
		document.activeElement?.blur();
	});

	// Mobile menu overlay: accordion submenus, collapsed by default.
	// Core treats every submenu inside an open overlay as open (state.isSubmenuOpen),
	// so the chevrons can't collapse them. We take over: an `is-open` class on the <li>
	// drives the CSS, and aria-expanded is kept in sync with it.
	document.querySelectorAll('.wp-block-navigation__overlay-container').forEach(function (overlay) {
		const submenus = overlay.querySelectorAll('li.wp-block-navigation-submenu');

		const syncExpanded = function (item) {
			const toggle = item.querySelector(':scope > .wp-block-navigation-submenu__toggle');
			const expanded = String(item.classList.contains('is-open'));

			if (toggle && toggle.getAttribute('aria-expanded') !== expanded) {
				toggle.setAttribute('aria-expanded', expanded);
			}
		};

		const collapseAll = function () {
			submenus.forEach(function (item) {
				item.classList.remove('is-open');
				syncExpanded(item);
			});
		};

		// Capture-phase listeners on the overlay run before core's handlers on the
		// <li> and toggle, so stopping propagation keeps core out of it.
		// Hover: don't expand/collapse rows as the mouse moves over the list.
		['pointerenter', 'pointerleave'].forEach(function (type) {
			overlay.addEventListener(
				type,
				function (event) {
					if (event.target !== overlay) {
						event.stopPropagation();
					}
				},
				true
			);
		});

		overlay.addEventListener(
			'click',
			function (event) {
				const toggle = event.target.closest('.wp-block-navigation-submenu__toggle');

				if (!toggle || !overlay.contains(toggle)) {
					return;
				}

				event.stopPropagation();
				toggle.parentElement.classList.toggle('is-open');
				syncExpanded(toggle.parentElement);
			},
			true
		);

		// Core re-binds aria-expanded to "true" when the overlay opens – put it back
		const observer = new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				syncExpanded(mutation.target.parentElement);
			});
		});

		submenus.forEach(function (item) {
			const toggle = item.querySelector(':scope > .wp-block-navigation-submenu__toggle');

			if (toggle) {
				observer.observe(toggle, { attributes: true, attributeFilter: ['aria-expanded'] });
			}
		});

		// Start collapsed every time the menu is opened
		const nav = overlay.closest('.wp-block-navigation');
		const openButton = nav && nav.querySelector('.wp-block-navigation__responsive-container-open');

		if (openButton) {
			openButton.addEventListener('click', collapseAll);
		}

		collapseAll();
	});

	// Temp: add 'has-modal-open is-menu-open' to wp-block-navigation__responsive-container on init
	/* document.querySelectorAll('.wp-block-navigation__responsive-container').forEach(function (nav) {
		setTimeout(() => {
			nav.classList.add('has-modal-open', 'is-menu-open');
			const firstItem = nav.querySelectorAll('.wp-block-navigation-submenu__toggle')[0];
			// toggle aria-expanded="true" to true for firstItem
			firstItem.setAttribute('aria-expanded', true)
		}, 500);
	}); */

	// Add a new responsive breakpoint for 1400px to the Slick Slider with the classes: .is-style-card-grid. wp-block-gb-for-slick-slider-slick-slider
	jQuery(function ($) {
		// `is-style-card-grid` sits on the block wrapper, but the plugin initialises
		// Slick on the `.gbss__viewport` child — that is what we have to patch.
		var cardGridViewport =
			'.wp-block-gb-for-slick-slider-slick-slider.is-style-card-grid > .gbss__viewport';

		// Nothing on this page to patch.
		if (!$(cardGridViewport).length) return;

		function addCardGridBreakpoint(viewport) {
			var $viewport = $(viewport);
			if (!$viewport.hasClass('slick-initialized')) return;

			$viewport.slick(
				'slickSetOption',
				'responsive',
				[
					{
						breakpoint: 1400,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
							infinite: true,
							dots: true,
						},
					},
				],
				true // refresh: re-registers breakpoints and re-evaluates the current one
			);
		}

		// Sliders initialised after this script runs: Slick fires 'init' on the viewport.
		$(document).on('init', cardGridViewport, () => {
			addCardGridBreakpoint(this);
		});

		// Sliders that were already initialised before this script ran.
		$(`${cardGridViewport}.slick-initialized`).each(function () {
			addCardGridBreakpoint(this);
		});
	});
})();
